import { loadSdk } from '../index.js'
import { insert, setVisible } from '@jsx6/jsx6'

export async function videoIdMedium(sdkUrl, accessToken, lang, documentTypes, chat){
  try {
    if (typeof EID === 'undefined') {
      console.log("EID is not defined, loading SDK...");
      await loadSdk(sdkUrl); // Load the SDK only if EID is not available
    } else {
      console.log("EID is already defined, skipping SDK load");
    }

    const reqCheck = await signicatRequirementsCheck()
    if(!document.getElementById('videoScan')){
      insert(document.body, <div id="videoScan" class="video-scan"></div>)
    }

    let language = chat.options.lang === 'si' ? 'sl': chat.options.lang === 'en' ? 'en': 'hr'
    setVisible(document.getElementById('videoScan'), true)
    const videoScan =  EID.videoScan('#videoScan', {
      lang: language,
      translations: {
        mainHeaderGenericTitle: ""
      }
    })
    
    
    
    videoScan.start({
      authorization: accessToken,
      eIDBiometricConsent: true,
      allowedIdTypes: documentTypes // https://etrust-sandbox.electronicid.eu/v2/videoid.idtypes
      //idType: is the idType of the document that will be used to perform the data extraction
      //allowedIdTypes: Optional list parameter. If specified, then the SDK will show a wizard to select the ID document type from the list of these ID types as long as they have beensub- scribed. If not specified then the SDK will show a wizard to select the ID document type from the list of ID document types the tenant is subscribed to.  
      //defaultIdType: Optional parameter. If specified, the list of available documents will set the country of this document by default. Can be used alongside with the parameter allowedId- Types
      //eIDBiometricConsent: Optional parameter. User consent about the usage of the personal and biometric data gathered during the identification for improving the process.
      //authorization: The VideoScan Authorization you got from a previous call to the API.
    })

    videoScan.on('completed', async ({ id })=>{
      /**
       * type video {
       *   id: string
       * }
       */
      let message = {
        "type" : "COMMAND",
        "action" : "scanId",
        "processed" : true,
        "data": {
          "method": "getVideoScanResults",
          "params" : {
            "videoId" : id
          },
          "provider": "SIGNICAT"
        }
      }
      chat.sendMessage(message)
      setVisible(document.getElementById('videoScan'), false)
    })
    
    videoScan.on('failed', (error)=>{
      /**
       * type error {
       *   error: {
       *     date: date;
       *     error: string;
       *     errorId: string;
       *     message: string;
       *   },
       *   notification: {
       *     ack: boolean;
       *     data: object;
       *     level: string;
       *     name: string;
       *     ttl: number;
       *     type: string;
       *   }
       * }
       */
      videoScan.turnOff()
      videoScan.destroy()
      setVisible(document.getElementById('videoScan'), false)
      let message = {
        "type" : "COMMAND",
        "action" : "scanId",
        "processed" : true,
        "data": {
          error: error?.message || "Signicat video scan error",
          "provider": "SIGNICAT"
        }
      }
      chat.sendMessage(message)
      console.log("There was an error during videoScan process: ", error)
    })

    videoScan.on('phaseStarting', (phase)=>{
      /**
       * type phase {
       *   continue: ()=>{} we need to call this in order to continue the process;
       *   name: string; // "Front", "Back"
       * }
       */
      phase.continue();
    })

  
    
    return videoScan
  } catch (error) {
    console.log("Error instantiating videoIdMedium instance: ", error)
  }
}



async function signicatRequirementsCheck(){
  try {
    let requirements = EID.videoScan.checkRequirementsEager();
    /**
     * type checks {
     *   passed: boolean;
     *   result: {
     *     browser: {};
     *     os: {},
     *     camera: {},
     *     microphone: {},
     *     bandwidth: {}
     *   }
     *
     * }
     */
    return await requirements
  } catch (error){
    console.log("Error during checking requirements:", error)
  }

}